import { motion, Variants, Transition } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

const FillContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Container = styled(motion.div)`
  width: 60px;
  height: 28px;
  display: flex;
  justify-content: space-around;
`

const Dot = styled(motion.div)`
  width: 12px;
  height: 12px;
  background: var(--neutral-80);
  border-radius: 50%;
`

const containerVariants: Variants = {
  start: {
    transition: {
      staggerChildren: 0.2
    }
  },
  end: {
    transition: {
      staggerChildren: 0.2
    }
  }
}

const loadingCircleVariants: Variants = {
  start: {
    y: '0%',
    opacity: 1
  },
  end: {
    y: '100%',
    opacity: 0.5
  }
}

const loadingCircleTransition: Transition = {
  duration: 0.5,
  repeat: Infinity,
  repeatType: 'mirror',
  ease: 'easeInOut'
}

const AnimatedDots = () => (
  <Container variants={containerVariants} initial="start" animate="end">
    <Dot variants={loadingCircleVariants} transition={loadingCircleTransition} />
    <Dot variants={loadingCircleVariants} transition={loadingCircleTransition} />
    <Dot variants={loadingCircleVariants} transition={loadingCircleTransition} />
  </Container>
)

interface Props {
  fill?: boolean
}
export const LoadingDots = ({ fill = false }: Props) => {
  if (fill) {
    return (
      <FillContainer>
        <AnimatedDots />
      </FillContainer>
    )
  }

  return <AnimatedDots />
}
